import {
  Article,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import type { SearchReturnRequestsResponseDto } from "@babackapp/private-api-client";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";

type LineItem = SearchReturnRequestsResponseDto["returnRequests"][number]["line_items"][number];

type Props = {
  lineItem: LineItem;
  currency: string;
  imageLayoutId?: string;
};

export function ReturnRequestLineItem({ lineItem, currency, imageLayoutId }: Props) {
  return (
    <Article variants={{}}>
      {lineItem.image && (
        <ArticleImage src={lineItem.image} layoutId={imageLayoutId} />
      )}
      <ArticleTitle>{lineItem.title}</ArticleTitle>
      <ArticleSubtitle>
        ×{lineItem.quantity} — {formatPrice(parseFloat(lineItem.price) * 100, currency)}
      </ArticleSubtitle>
    </Article>
  );
}
